import { cn } from "@/lib/utils";

/**
 * Aimly belgisi — web ilovadagi logo va favicon bilan bir xil shakl:
 * ikki ochiq halqa (reja davrlari), marjon markaz (maqsad) va yuqoriga
 * chiquvchi strelka (har bir vazifa maqsadni oldinga siljitadi).
 */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="9" className="fill-brand-panel" />
      <path
        d="M25.99 12.76A10.5 10.5 0 1 1 19.24 6.01"
        fill="none"
        strokeWidth="2.4"
        strokeLinecap="round"
        className="stroke-brand-panel-foreground"
      />
      <path
        d="M21.42 15.05A5.5 5.5 0 1 1 16.95 10.58"
        fill="none"
        strokeWidth="2.4"
        strokeLinecap="round"
        className="stroke-brand-accent"
      />
      <path
        d="M16 16 24.4 7.6M19.6 7.2h5.2v5.2"
        fill="none"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-primary"
      />
      <circle cx="16" cy="16" r="2.4" className="fill-primary" />
    </svg>
  );
}

/** So'z belgisi: kichik harfli "aimly" — "aim" asosiy rangda, "ly" marjon (web bilan bir xil). */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("font-heading font-semibold tracking-tight", className)}>
      <span className="sr-only">Aimly</span>
      <span aria-hidden>
        aim<span className="text-primary">ly</span>
      </span>
    </span>
  );
}
